module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@3x-bab99b8a27fe85acf3b0a27a3fe07a1e.png";